import React from "react";
import styled from "@emotion/styled";
import { Box, SxProps, Theme, useTheme } from "@mui/material";
import { ShowcaseLayout } from "@components";

const FormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};
  padding: ${({ theme }) => theme.spacing(0, 6)};
  max-width: 700px;
  width: 100%;
  margin: auto 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    max-width: none;
    padding: 0;
    margin: 0;
  }
`;

type Props = {
  children: React.ReactNode;
  containerSx?: SxProps<Theme>;
};

export const LoginPagesLayout = ({ children, containerSx }: Props) => {
  const theme = useTheme();

  return (
    <ShowcaseLayout img={theme.showcaseLayout?.image}>
      <FormContainer sx={containerSx}>{children}</FormContainer>
    </ShowcaseLayout>
  );
};
